(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.StepsController = (function(superClass) {
    extend(StepsController, superClass);

    function StepsController(scope, transitions, service, state, modal, http, ngModal) {
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.state = state;
      this.modal = modal;
      this.http = http;
      this.ngModal = ngModal;
      this.exitFieldprint = bind(this.exitFieldprint, this);
      this.showValidationErrorMessage = bind(this.showValidationErrorMessage, this);
      this.openUploadedPBIConnections = bind(this.openUploadedPBIConnections, this);
      this.openPBIConnections = bind(this.openPBIConnections, this);
      this.openOtherPractices = bind(this.openOtherPractices, this);
      this.loadUploadedPBIConnection = bind(this.loadUploadedPBIConnection, this);
      this.isOnLastStep = bind(this.isOnLastStep, this);
      this.isOnFirstStep = bind(this.isOnFirstStep, this);
      this.saveFieldprint = bind(this.saveFieldprint, this);
      this.gotoNextStep = bind(this.gotoNextStep, this);
      this.gotoPrevStep = bind(this.gotoPrevStep, this);
      StepsController.__super__.constructor.apply(this, arguments);
      this.scope.fullpage = true;
      this.scope.service = this.service;
      this.scope.isUploadedPBIConnected = false;
      this.service.loadConfig().then((function(_this) {
        return function() {
          if (_.isEmpty(_this.service.fpcResult) && _this.state.params.id && _this.state.params.step) {
            return _this.service.loadFieldprint(_this.state.params.id).then(function() {
              return _this.service.gotoStep(_this.state.params.step - 1, _this.state.params.id, false);
            });
          }
        };
      })(this));
      this.scope.$watch('service.fpcResult.data', (function(_this) {
        return function(n, o) {
          return _this.service.calculateCompleteness();
        };
      })(this), true);
      this.scope.$watch('service.showIncompletenessMessage', (function(_this) {
        return function(show, o) {
          if (show) {
            return _this.showValidationErrorMessage();
          } else {
            return _this.writer.hide();
          }
        };
      })(this), true);
      this.scope.$watch('service.changeStepFromSidebar', (function(_this) {
        return function(n, o) {
          if (_this.service.showIncompletenessMessage) {
            _this.writer.hide();
            return _this.showValidationErrorMessage();
          }
        };
      })(this), true);
      this.writer = $('.absolute-errorDiv').message_writer({
        autoHide: false
      });
      this.loadUploadedPBIConnection();
    }

    StepsController.prototype.gotoPrevStep = function() {
      return this.service.gotoStep(this.service.currentStepIndex - 1);
    };

    StepsController.prototype.gotoNextStep = function() {
      return this.service.gotoStep(this.service.currentStepIndex + 1);
    };

    StepsController.prototype.saveFieldprint = function(triggerMissing) {
      this.service.save(this.service.state.params.id);
      if (triggerMissing) {
        if (this.service.triggerMissing(this.service.currentStepIndex + 1)) {
          this.service.showIncompletenessMessage = true;
          this.service.changeStepFromSidebar = false;
          return;
        }
      }
      if (!this.service.hasOtherPractices) {
        this.openOtherPractices();
        return;
      }
      if (!this.service.isFieldLinkedExternally && this.service.hasPBIConnection && this.scope.isUploadedPBIConnected && !this.service.isFieldLinkedUploadedPbi) {
        return this.http.post('backend/grower/fieldprint/check-launch-auto-manage-connections', this.service.fpcResult.events['planting']).then((function(_this) {
          return function(response) {
            if (response.data) {
              return _this.openPBIConnections().then(function() {
                return _this.openUploadedPBIConnections().then(function() {
                  return _this.exitFieldprint();
                }, function() {
                  return _this.exitFieldprint();
                });
              });
            } else {
              return _this.exitFieldprint();
            }
          };
        })(this));
      } else if (!this.service.isFieldLinkedExternally && this.service.hasPBIConnection) {
        return this.http.post('backend/grower/fieldprint/check-launch-auto-manage-connections', this.service.fpcResult.events['planting']).then((function(_this) {
          return function(response) {
            if (response.data) {
              return _this.openPBIConnections().then(function() {
                return _this.exitFieldprint();
              }, function() {
                return _this.exitFieldprint();
              });
            } else {
              return _this.exitFieldprint();
            }
          };
        })(this));
      } else if (this.scope.isUploadedPBIConnected && !this.service.isFieldLinkedUploadedPbi) {
        return this.http.post('backend/grower/fieldprint/check-launch-auto-manage-connections', this.service.fpcResult.events['planting']).then((function(_this) {
          return function(response) {
            if (response.data) {
              return _this.openUploadedPBIConnections().then(function() {
                return _this.exitFieldprint();
              }, function() {
                return _this.exitFieldprint();
              });
            } else {
              return _this.exitFieldprint();
            }
          };
        })(this));
      } else {
        return this.exitFieldprint();
      }
    };

    StepsController.prototype.isOnFirstStep = function() {
      return this.service.currentStepIndex === 0;
    };

    StepsController.prototype.isOnLastStep = function() {
      var ref, ref1;
      if (((ref = this.service.config) != null ? (ref1 = ref[this.service.crop]) != null ? ref1.steps : void 0 : void 0) == null) {
        return false;
      }
      return this.service.currentStepIndex === Object.keys(this.service.config[this.service.crop].steps.value).length - 1;
    };

    StepsController.prototype.loadUploadedPBIConnection = function() {
      return this.service.hasPBIUploadedConnection(this.service.year).then((function(_this) {
        return function(response) {
          return _this.scope.isUploadedPBIConnected = response.data;
        };
      })(this));
    };

    StepsController.prototype.openOtherPractices = function() {
      var dialogClosed;
      dialogClosed = (function(_this) {
        return function() {
          if (!_this.service.isFieldLinkedExternally && _this.service.hasPBIConnection && _this.scope.isUploadedPBIConnected && !_this.service.isFieldLinkedUploadedPbi) {
            return _this.openPBIConnections().then(function() {
              return _this.openUploadedPBIConnections().then(function() {
                return _this.exitFieldprint();
              }, function() {
                return _this.exitFieldprint();
              });
            });
          } else if (!_this.service.isFieldLinkedExternally && _this.service.hasPBIConnection) {
            return _this.openPBIConnections().then(function() {
              return _this.exitFieldprint();
            }, function() {
              return _this.exitFieldprint();
            });
          } else if (_this.scope.isUploadedPBIConnected && !_this.service.isFieldLinkedUploadedPbi) {
            return _this.openUploadedPBIConnections().then(function() {
              return _this.exitFieldprint();
            }, function() {
              return _this.exitFieldprint();
            });
          } else {
            return _this.exitFieldprint();
          }
        };
      })(this);
      if (this.service.hasSaifsaOtherPractices) {
        return this.ngModal.launchFsaOtherPractices(this.service.year, this.service.crop).then((function(_this) {
          return function(result) {
            return result.modalRef.result.then(function() {
              return dialogClosed();
            }, function() {
              return dialogClosed();
            });
          };
        })(this));
      } else {
        return this.http.post('backend/grower/other-practices/load', {
          year: this.service.year,
          crop: this.service.crop
        }).then((function(_this) {
          return function(response) {
            return _this.modal.open({
              windowClass: 'medium_dialog',
              controller: 'Fieldprint.Controllers.OtherPracticesController',
              templateUrl: 'backend/grower/fieldprint/other-practices-dialog',
              scope: _this.scope.$new(),
              resolve: {
                selections: function() {
                  return {
                    year: _this.service.year,
                    crop: _this.service.crop
                  };
                },
                survey: function() {
                  return response.data;
                }
              }
            }).result.then(function() {
              return dialogClosed();
            });
          };
        })(this));
      }
    };

    StepsController.prototype.openPBIConnections = function() {
      return this.ngModal.openPBIConnectionsDialog('edit', this.service.year, this.service.fpcResult.field, true).modalRef.result;
    };

    StepsController.prototype.openUploadedPBIConnections = function() {
      return this.ngModal.openUploadedPBIConnectionsDialog('edit', this.service.year, this.service.fpcResult.field, true).modalRef.result;
    };

    StepsController.prototype.showValidationErrorMessage = function() {
      var verb;
      if (this.service.changeStepFromSidebar) {
        verb = 'try again';
      } else if (this.isOnLastStep()) {
        verb = 'click "Save + Close"';
      } else {
        verb = 'click "Next"';
      }
      return this.writer.message_writer('error', "Some required information is missing. Please complete the areas highlighted orange and " + verb + ".");
    };

    StepsController.prototype.exitFieldprint = function() {
      this.service.field = null;
      return this.state.go('grower.fieldprint', {}, {
        reload: 'grower.fieldprint'
      });
    };

    return StepsController;

  })(Controller);

}).call(this);
